/* ============================================================
   OXFORD DIAMOND CO. — THEME JS
   ============================================================ */

(function () {
  'use strict';

  /* ============ SCROLL REVEAL ============ */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          observer.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));

  /* ============ CART DRAWER ============ */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartCount = document.querySelector('[data-cart-count]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCart();
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
      closeCart();
    }
  });

  /* ============ ADD TO CART (AJAX) ============ */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    const isQuickAdd = form.classList.contains('product-card__quick-add');
    const submitBtn = form.querySelector('[type="submit"]');
    const originalText = submitBtn ? submitBtn.textContent : '';

    if (submitBtn && !isQuickAdd) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      if (!res.ok) throw new Error('add to cart failed');

      if (isQuickAdd) {
        // brief "added" pulse on the card button, then open drawer
        form.classList.add('is-added');
        const icon = form.querySelector('svg');
        if (icon) {
          icon.innerHTML = '<polyline points="20 6 9 17 4 12"></polyline>';
        }
        setTimeout(() => {
          form.classList.remove('is-added');
          if (icon) icon.innerHTML = '<path d="M12 5v14M5 12h14"/>';
          openCart();
        }, 600);
      } else {
        openCart();
      }
    } catch (err) {
      console.error(err);
      if (submitBtn && !isQuickAdd) {
        submitBtn.textContent = 'Try again';
        setTimeout(() => { submitBtn.textContent = originalText; }, 2000);
      }
    } finally {
      if (submitBtn && !isQuickAdd) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
      }
    }
  });

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      renderCart(cart);
    } catch (err) { console.error(err); }
  }
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '$' + amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }
  function renderCart(cart) {
    if (cartCount) cartCount.textContent = '[' + cart.item_count + ']';
    const body = document.querySelector('[data-cart-body]');
    const total = document.querySelector('[data-cart-total]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty"><p>YOUR BAG IS EMPTY</p>' +
        '<a href="/collections/all" class="btn">Shop Collections →</a></div>';
      if (total) total.textContent = '';
      return;
    }
    body.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-line-key="${item.key}">
        <div class="cart-item__image">
          ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
        </div>
        <div>
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <button class="cart-item__remove" data-line-remove="${item.key}">Remove</button>
        </div>
        <div class="cart-item__qty">${item.quantity}</div>
      </div>
    `).join('');
    if (total) {
      total.innerHTML = `<span>Subtotal</span><b>${formatMoney(cart.total_price)}</b>`;
    }
  }
  document.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-line-remove]');
    if (!removeBtn) return;
    const key = removeBtn.getAttribute('data-line-remove');
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      if (res.ok) {
        const cart = await res.json();
        renderCart(cart);
        // if we're on the cart page, remove the line and update totals
        const lineEl = document.querySelector(`.cart-line[data-line-key="${key}"]`);
        if (lineEl) {
          lineEl.style.transition = 'opacity .3s ease';
          lineEl.style.opacity = '0';
          setTimeout(() => {
            if (cart.item_count === 0) {
              window.location.reload();
            } else {
              lineEl.remove();
              updateCartPageTotals(cart);
            }
          }, 300);
        }
      }
    } catch (err) { console.error(err); }
  });

  /* ============ CART PAGE QUANTITY CONTROLS ============ */
  function updateCartPageTotals(cart) {
    const subtotalEl = document.querySelector('[data-cart-page-subtotal]');
    const totalEl = document.querySelector('[data-cart-page-total]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price || cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    const itemCountEl = document.querySelector('.cart-page__head p');
    if (itemCountEl) itemCountEl.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;

    // free shipping bar
    const bar = document.querySelector('[data-shipping-bar]');
    if (bar) {
      const threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      const subtotal = cart.items_subtotal_price || cart.total_price;
      const remaining = Math.max(0, threshold - subtotal);
      const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
      const fill = bar.querySelector('[data-shipping-fill]');
      if (fill) fill.style.width = pct + '%';

      if (subtotal >= threshold) {
        bar.classList.add('is-qualified');
        bar.querySelector('.shipping-bar__head').innerHTML =
          '<span><strong>Free shipping unlocked.</strong> Your order qualifies.</span>';
      } else {
        bar.classList.remove('is-qualified');
        bar.querySelector('.shipping-bar__head').innerHTML =
          `<span>You're <strong>${formatMoney(remaining)}</strong> away from free shipping</span>` +
          `<span>${pct}%</span>`;
      }
    }
  }

  /* gift message toggle */
  const giftToggle = document.querySelector('[data-gift-toggle]');
  const giftField = document.querySelector('[data-gift-field]');
  if (giftToggle && giftField) {
    // open if value already set
    const giftInput = giftField.querySelector('input');
    if (giftInput && giftInput.value) {
      giftToggle.checked = true;
      giftField.classList.add('is-open');
    }
    giftToggle.addEventListener('change', () => {
      giftField.classList.toggle('is-open', giftToggle.checked);
      if (!giftToggle.checked && giftInput) giftInput.value = '';
    });
  }

  /* promo code toggle */
  const promoToggle = document.querySelector('[data-promo-toggle]');
  const promoField = document.querySelector('[data-promo-field]');
  if (promoToggle && promoField) {
    promoToggle.addEventListener('click', () => {
      promoField.classList.toggle('is-open');
      promoToggle.textContent = promoField.classList.contains('is-open')
        ? '− Hide promo code'
        : '+ Add promo code';
    });
  }

  async function updateLineQuantity(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (!res.ok) return;
      const cart = await res.json();
      // update the line price
      const lineEl = document.querySelector(`.cart-line[data-line-key="${key}"]`);
      if (lineEl) {
        if (qty === 0) {
          lineEl.style.transition = 'opacity .3s ease';
          lineEl.style.opacity = '0';
          setTimeout(() => {
            if (cart.item_count === 0) {
              window.location.reload();
            } else {
              lineEl.remove();
              updateCartPageTotals(cart);
            }
          }, 300);
          return;
        }
        const updatedItem = cart.items.find((i) => i.key === key);
        if (updatedItem) {
          const priceEl = lineEl.querySelector('.cart-line__price');
          if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price);
        }
      }
      updateCartPageTotals(cart);
      renderCart(cart);
    } catch (err) { console.error(err); }
  }

  // increase / decrease buttons
  document.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-qty-decrease]');
    const inc = e.target.closest('[data-qty-increase]');
    if (!dec && !inc) return;
    const wrap = (dec || inc).closest('.cart-line__qty');
    if (!wrap) return;
    const input = wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const key = input.getAttribute('data-line-key');
    let qty = parseInt(input.value, 10) || 0;
    qty = inc ? qty + 1 : Math.max(0, qty - 1);
    input.value = qty;
    updateLineQuantity(key, qty);
  });

  // direct input change
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const key = input.getAttribute('data-line-key');
    const qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;
    updateLineQuantity(key, qty);
  });

  /* ============ PRODUCT GALLERY (thumb switching) ============ */
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const fullSrc = thumb.getAttribute('data-full');
        const alt = thumb.getAttribute('data-alt') || '';
        if (main && fullSrc) {
          main.querySelector('img').src = fullSrc;
          main.querySelector('img').alt = alt;
        }
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /* ============ PRODUCT VARIANT SELECTOR ============ */
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantData = form.getAttribute('data-variants');
    if (!variantData) return;
    let variants;
    try { variants = JSON.parse(variantData); } catch (err) { return; }

    const variantInput = form.querySelector('[name="id"]');
    const submitBtn = form.querySelector('[type="submit"]');
    const galleryMain = document.querySelector('[data-gallery-main] img');

    function getSelectedOptions() {
      const opts = [];
      form.querySelectorAll('[data-option-index]').forEach((wrap) => {
        const idx = parseInt(wrap.getAttribute('data-option-index'), 10);
        const sel = wrap.querySelector('[data-option-value].is-selected, .swatch.is-selected');
        if (sel) opts[idx] = sel.getAttribute('data-option-value');
      });
      return opts;
    }

    function findVariant() {
      const selected = getSelectedOptions();
      return variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    }

    function formatVariantPrice(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    function updateSelectedNames() {
      form.querySelectorAll('[data-option-index]').forEach((wrap) => {
        const sel = wrap.querySelector('[data-option-value].is-selected, .swatch.is-selected');
        const nameEl = wrap.querySelector('[data-selected-name]');
        if (sel && nameEl) nameEl.textContent = sel.getAttribute('data-option-value');
      });
    }

    function updateVariant() {
      const v = findVariant();
      updateSelectedNames();

      if (!v) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Unavailable';
        }
        return;
      }

      if (variantInput) variantInput.value = v.id;

      // price — update the whole .product-info__price wrapper so we don't lose the data-attr element
      const priceWrap = form.querySelector('.product-info__price');
      if (priceWrap) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWrap.innerHTML =
            '<span class="compare" data-product-compare>' + formatVariantPrice(v.compare_at_price) + '</span>' +
            ' <span class="sale" data-product-price>' + formatVariantPrice(v.price) + '</span>';
        } else {
          priceWrap.innerHTML = '<span data-product-price>' + formatVariantPrice(v.price) + '</span>';
        }
      }

      // submit button state
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? 'Add to bag →' : 'Sold out';
      }

      // swap main image if variant has its own image
      if (v.featured_image && galleryMain) {
        const newSrc = v.featured_image.src
          ? v.featured_image.src.replace(/(\?.*)?$/, '?width=1400')
          : null;
        if (newSrc) {
          galleryMain.src = newSrc;
          galleryMain.alt = v.featured_image.alt || '';
        }

        // also update the active thumb
        const thumbs = document.querySelectorAll('[data-gallery-thumb]');
        thumbs.forEach((t) => {
          const full = t.getAttribute('data-full') || '';
          const matches = v.featured_image.src && full.includes(v.featured_image.src.split('?')[0].split('/').pop().split('.')[0]);
          if (matches) {
            thumbs.forEach((tt) => tt.classList.remove('is-active'));
            t.classList.add('is-active');
          }
        });
      }

      // update url with variant param (no reload)
      try {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (err) {}
    }

    // parse the variant→options map (used for filtering later options by earlier selections)
    let variantMap = [];
    const mapEl = form.querySelector('[data-variant-options-map]');
    if (mapEl) {
      try { variantMap = JSON.parse(mapEl.textContent.trim()); } catch (err) {
        console.warn('Variant map parse failed', err);
        variantMap = [];
      }
    }

    function filterDependentOptions() {
      // if no map available, show everything (fail-open)
      if (!variantMap.length) return;
      const selected = getSelectedOptions();
      const groups = form.querySelectorAll('[data-option-index]');

      groups.forEach((group) => {
        const gIdx = parseInt(group.getAttribute('data-option-index'), 10);
        if (gIdx === 0) return; // option 1 always shows everything

        // if no earlier option is selected yet, leave this group untouched (show all)
        let allPrevSelected = true;
        for (let i = 0; i < gIdx; i++) {
          if (!selected[i]) { allPrevSelected = false; break; }
        }
        if (!allPrevSelected) return;

        // valid values for this option = values that have at least one variant
        // matching all previously-selected options
        const validValues = new Set();
        variantMap.forEach((v) => {
          let matchesPrev = true;
          for (let i = 0; i < gIdx; i++) {
            if (v.options[i] !== selected[i]) {
              matchesPrev = false;
              break;
            }
          }
          if (matchesPrev && v.options[gIdx]) {
            validValues.add(v.options[gIdx]);
          }
        });

        // safety: if we'd hide everything, leave the group alone
        if (validValues.size === 0) return;

        // show/hide buttons in this group
        let hasSelectedVisible = false;
        let firstVisibleBtn = null;
        group.querySelectorAll('.swatch, [data-option-value]').forEach((btn) => {
          const val = btn.getAttribute('data-option-value');
          if (validValues.has(val)) {
            btn.style.display = '';
            if (!firstVisibleBtn) firstVisibleBtn = btn;
            if (btn.classList.contains('is-selected')) hasSelectedVisible = true;
          } else {
            btn.style.display = 'none';
            btn.classList.remove('is-selected');
          }
        });

        // if the previously-selected value is now hidden, auto-select the first visible one
        if (!hasSelectedVisible && firstVisibleBtn) {
          firstVisibleBtn.classList.add('is-selected');
        }
      });
    }

    // unified click handler for both swatches and value pills
    form.querySelectorAll('.swatch, [data-option-value]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        // sold-out swatches: still allow selection but show sold out state
        const wrap = btn.closest('[data-option-index]');
        if (!wrap) return;
        wrap.querySelectorAll('.swatch, [data-option-value]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        filterDependentOptions();
        updateVariant();
      });
    });

    // run once on page load to set the initial state
    filterDependentOptions();
  });

  /* ============ NEWSLETTER POPUP ============ */
  const POPUP_KEY = 'odc_popup_seen_v1';
  const popup = document.querySelector('[data-popup]');
  const popupOverlay = document.querySelector('[data-popup-overlay]');
  function openPopup() { if (popupOverlay) popupOverlay.classList.add('is-open'); }
  function closePopup() {
    if (popupOverlay) popupOverlay.classList.remove('is-open');
    try { localStorage.setItem(POPUP_KEY, '1'); } catch (err) {}
  }
  if (popup && popupOverlay) {
    let seen = false;
    try { seen = localStorage.getItem(POPUP_KEY) === '1'; } catch (err) {}
    if (!seen) setTimeout(openPopup, 6000);
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-popup-close]') || e.target.matches('[data-popup-overlay]')) {
        closePopup();
      }
    });
  }

  /* ============ QUICK VIEW MODAL ============ */
  const quickOverlay = document.querySelector('[data-quick-overlay]');
  const quickModal = document.querySelector('[data-quick-modal]');

  async function openQuickView(handle) {
    if (!handle || !quickModal) return;
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return;
      const product = await res.json();
      quickModal.querySelector('[data-quick-image]').innerHTML = product.featured_image
        ? `<img src="${product.featured_image}" alt="${product.title}">`
        : '';
      quickModal.querySelector('[data-quick-title]').textContent = product.title;
      quickModal.querySelector('[data-quick-price]').textContent = formatMoney(product.price);
      quickModal.querySelector('[data-quick-desc]').innerHTML = product.description
        ? product.description.split('</p>')[0] + (product.description.includes('</p>') ? '</p>' : '')
        : '';
      quickModal.querySelector('[data-quick-link]').href = product.url;
      const form = quickModal.querySelector('[data-quick-form]');
      if (form) {
        const idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.value = product.variants[0].id;
      }
      quickOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    } catch (err) {
      console.error(err);
    }
  }
  function closeQuickView() {
    if (quickOverlay) quickOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-open]');
    if (trigger) {
      e.preventDefault();
      openQuickView(trigger.getAttribute('data-quick-open'));
      return;
    }
    if (e.target.closest('[data-quick-close]') || e.target.matches('[data-quick-overlay]')) {
      closeQuickView();
    }
  });

  /* ============ RECENTLY VIEWED ============ */
  const RV_KEY = 'odc_recently_viewed_v1';
  const RV_MAX = 8;

  function getRecentlyViewed() {
    try {
      const raw = localStorage.getItem(RV_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (err) { return []; }
  }
  function addToRecentlyViewed(handle) {
    if (!handle) return;
    let list = getRecentlyViewed().filter((h) => h !== handle);
    list.unshift(handle);
    list = list.slice(0, RV_MAX);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (err) {}
  }

  // If we're on a product page, log the current product
  const currentProductHandle = document.querySelector('[data-current-product]');
  if (currentProductHandle) {
    addToRecentlyViewed(currentProductHandle.getAttribute('data-current-product'));
  }

  // Render recently viewed grid if present
  async function renderRecentlyViewed() {
    const grid = document.querySelector('[data-recently-viewed]');
    if (!grid) return;
    const currentHandle = currentProductHandle ? currentProductHandle.getAttribute('data-current-product') : null;
    const handles = getRecentlyViewed().filter((h) => h !== currentHandle).slice(0, 4);
    if (handles.length === 0) {
      grid.innerHTML = '<p class="recently-viewed__empty">No recently viewed pieces yet — start browsing.</p>';
      return;
    }
    try {
      const products = await Promise.all(
        handles.map((h) => fetch(`/products/${h}.js`).then((r) => (r.ok ? r.json() : null)))
      );
      grid.innerHTML = products
        .filter(Boolean)
        .map((p) => {
          const hasOneVariant = p.variants && p.variants.length === 1;
          const available = p.available;
          const addBtn = !available
            ? `<span class="product-card__badge">Sold out</span>`
            : hasOneVariant
              ? `<form action="/cart/add" method="post" class="product-card__quick-add">
                   <input type="hidden" name="id" value="${p.variants[0].id}">
                   <button type="submit" aria-label="Add ${p.title} to bag">
                     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
                   </button>
                 </form>`
              : `<button type="button" class="product-card__quick-add" data-quick-open="${p.handle}" aria-label="Quick view ${p.title}">
                   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
                 </button>`;
          return `
            <div class="product-card">
              <a href="${p.url}" class="product-card__media-link">
                <div class="product-card__media">
                  ${p.featured_image ? `<img src="${p.featured_image}" alt="${p.title}" loading="lazy">` : ''}
                  ${addBtn}
                  <button type="button" class="product-card__quick" data-quick-open="${p.handle}" aria-label="Quick view ${p.title}">Quick view</button>
                </div>
              </a>
              <a href="${p.url}" class="product-card__title">${p.title}</a>
              <div class="product-card__price">${formatMoney(p.price)}</div>
            </div>
          `;
        }).join('');
    } catch (err) { console.error(err); }
  }
  renderRecentlyViewed();

  /* ============ COLLECTION SEARCH (full-catalog via Predictive Search API) ============ */
  (function () {
    const wrap = document.querySelector('[data-collection-search]');
    const input = document.querySelector('[data-collection-search-input]');
    const grid = document.querySelector('[data-collection-grid]');
    const emptyState = document.querySelector('[data-collection-search-empty]');
    const termEl = document.querySelector('[data-collection-search-term]');
    const countLabel = document.querySelector('[data-collection-search-count]');
    const countNum = document.querySelector('[data-collection-search-count-num]');
    const countTerm = document.querySelector('[data-collection-search-count-term]');
    const clearBtn = wrap ? wrap.querySelector('[data-collection-search-clear]') : null;
    const clearBtn2 = document.querySelector('[data-collection-search-clear2]');
    if (!wrap || !input || !grid) return;

    const collectionHandle = wrap.getAttribute('data-collection-handle') || '';
    const collectionUrl = grid.getAttribute('data-collection-url') || '';

    // stash the original grid HTML so we can restore it when the user clears the search
    const originalGridHTML = grid.innerHTML;
    // stash the original pagination too if it exists
    const paginationEl = document.querySelector('.pagination');
    const contentWrap = document.querySelector('[data-collection-content]');

    let currentRequest = null;
    let debounceTimer = null;
    let currentQuery = '';

    function money(cents) {
      const amount = (cents / 100).toFixed(2);
      return '$' + amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    function renderProductCard(p) {
      // p is a Shopify Predictive Search product object
      const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      const priceMin = (p.price_min != null) ? p.price_min : (p.price || 0);
      const compareMin = (p.compare_at_price_min != null) ? p.compare_at_price_min : 0;
      const hasSale = compareMin > priceMin;
      const priceHTML = hasSale
        ? `<span class="product-card__compare">${money(compareMin)}</span> <span class="product-card__sale">${money(priceMin)}</span>`
        : money(priceMin);

      // decide add-to-bag button: single variant → direct add, multi → quick view
      const variantsCount = p.variants ? p.variants.length : 1;
      const firstAvailable = p.variants && p.variants.find(v => v.available);
      const addBtn = !firstAvailable
        ? `<span class="product-card__badge">Sold out</span>`
        : variantsCount === 1
          ? `<form action="/cart/add" method="post" class="product-card__quick-add">
               <input type="hidden" name="id" value="${p.variants[0].id}">
               <button type="submit" aria-label="Add ${(p.title || '').replace(/"/g,'')} to bag">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
               </button>
             </form>`
          : `<button type="button" class="product-card__quick-add" data-quick-open="${p.handle}" aria-label="Quick view ${(p.title || '').replace(/"/g,'')}">
               <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14M5 12h14"/></svg>
             </button>`;

      return `
        <div class="product-grid__item">
          <div class="product-card">
            <a href="${p.url}" class="product-card__media-link">
              <div class="product-card__media">
                ${img ? `<img src="${img}" alt="${(p.title || '').replace(/"/g,'')}" loading="lazy">` : ''}
                ${addBtn}
                <button type="button" class="product-card__quick" data-quick-open="${p.handle}" aria-label="Quick view ${(p.title || '').replace(/"/g,'')}">Quick view</button>
              </div>
            </a>
            <a href="${p.url}" class="product-card__title">${p.title}</a>
            <div class="product-card__price">${priceHTML}</div>
          </div>
        </div>
      `;
    }

    function showEmpty(term) {
      if (emptyState) {
        emptyState.hidden = false;
        if (termEl) termEl.textContent = '"' + term + '"';
      }
      grid.innerHTML = '';
    }

    function showResults(products, term) {
      if (emptyState) emptyState.hidden = true;
      grid.innerHTML = products.map(renderProductCard).join('');
      if (countNum) countNum.textContent = products.length;
      if (countTerm) countTerm.textContent = '"' + term + '"';
    }

    function restoreOriginal() {
      grid.innerHTML = originalGridHTML;
      if (emptyState) emptyState.hidden = true;
      if (contentWrap) contentWrap.classList.remove('is-search-active');
    }

    async function search(query) {
      const q = (query || '').trim();
      if (q === '') {
        wrap.classList.remove('has-value', 'is-loading');
        restoreOriginal();
        return;
      }
      wrap.classList.add('has-value', 'is-loading');

      // abort in-flight request if new one comes in
      if (currentRequest) {
        currentRequest.abort();
      }

      const controller = new AbortController();
      currentRequest = controller;

      try {
        // Predictive Search API: search entire catalog for products, then filter to this collection
        const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=50&resources[options][fields]=title,product_type,variants.title,vendor,tag';
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error('search failed');
        const data = await res.json();

        let products = (data.resources && data.resources.results && data.resources.results.products) || [];

        // scope to the current collection if we know its handle
        if (collectionHandle) {
          products = products.filter((p) => {
            if (!p.url) return true;
            // Predictive Search puts collection in URL if it exists; otherwise just check the tag
            return true; // keep for now, we'll filter below more strictly
          });
        }

        // If we have a collection handle, do a second-pass filter using a collection-scoped predictive search
        // Shopify doesn't scope predictive search to a collection natively, so we filter client-side by checking
        // the /collections/{handle}/products.json endpoint OR by hitting /search with an unfiltered_type + tag filter.
        // Simplest reliable approach: do a second fetch of ALL products in this collection (paginated) and intersect.

        // If in this collection scope, verify each result belongs to it via the collection's products.json feed
        if (collectionHandle) {
          const collectionProducts = await fetchCollectionHandles(collectionHandle);
          products = products.filter((p) => collectionProducts.has(p.handle));
        }

        if (products.length === 0) {
          showEmpty(q);
        } else {
          showResults(products, q);
        }
        if (contentWrap) contentWrap.classList.add('is-search-active');
      } catch (err) {
        if (err.name === 'AbortError') return; // ignore aborted requests
        console.error('Collection search error', err);
      } finally {
        wrap.classList.remove('is-loading');
      }
    }

    // cache the set of handles that belong to this collection (fetched once, reused)
    let collectionHandlesCache = null;
    async function fetchCollectionHandles(handle) {
      if (collectionHandlesCache) return collectionHandlesCache;
      const set = new Set();
      // fetch up to 5 pages of 250 products (1250 max) — plenty for any jewelry catalog
      for (let page = 1; page <= 5; page++) {
        try {
          const res = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
          if (!res.ok) break;
          const data = await res.json();
          const items = data.products || [];
          if (items.length === 0) break;
          items.forEach((p) => set.add(p.handle));
          if (items.length < 250) break; // last page
        } catch (err) { break; }
      }
      collectionHandlesCache = set;
      return set;
    }

    input.addEventListener('input', (e) => {
      currentQuery = e.target.value;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (e.target.value === currentQuery) search(currentQuery);
      }, 260);
    });

    function clearAll() {
      input.value = '';
      currentQuery = '';
      search('');
      input.focus();
    }
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
    if (clearBtn2) clearBtn2.addEventListener('click', clearAll);
  })();

  /* ============ FAQ ACCORDION ============ */
  document.querySelectorAll('[data-faq-item]').forEach((item) => {
    const trigger = item.querySelector('[data-faq-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      item.classList.toggle('is-open');
    });
  });

  /* ============ SIZE GUIDE ROW HIGHLIGHT ============ */
  document.querySelectorAll('[data-chain-row]').forEach((row) => {
    row.addEventListener('mouseenter', () => {
      const all = row.parentElement.querySelectorAll('[data-chain-row]');
      all.forEach((r) => r.classList.remove('is-active'));
      row.classList.add('is-active');
    });
  });

  refreshCart();
})();
